// @ts-nocheck
import React, { useMemo } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { Route as RouteNeo } from '../Constants/Routes.constants';
import { isUserConfirmingEmail, isUserVerifyingEmail } from '../Helpers/Route.helpers';
import { EmailVerificationEnum } from '~/Models/DTO/User.model';
import { useLocalStorage, useUserWithoutContext } from '~/Hooks';
import { JumpingLoader } from '~/UIKit';

const { HOME } = RouteNeo;

interface PublicRouteProps extends RouteProps {
  layout?: ReactNode;
  layoutProps?: any; // @TODO specify layout props
}

const PublicRoute = ({ component, layout, layoutProps, ...rest }: PublicRouteProps) => {
  const { accessToken } = useLocalStorage();
  const { currentUser, isCurrentUserLoading } = useUserWithoutContext();
  const publicAccess = useMemo(
    () =>
      isUserVerifyingEmail()
        ? currentUser?.isVerified === EmailVerificationEnum.NOT_VERIFIED
        : !accessToken || isUserConfirmingEmail(),
    [currentUser?.isVerified, accessToken, location.pathname],
  );
  if (isCurrentUserLoading) {
    return <JumpingLoader />;
  }
  const Component = component;
  const Layout = layout;
  return (
    <Route
      {...rest}
      render={(props) =>
        publicAccess ? (
          layout ? (
            <Layout {...props} {...layoutProps}>
              <Component {...props} />
            </Layout>
          ) : (
            <Component {...props} />
          )
        ) : (
          <Redirect to={HOME} />
        )
      }
    />
  );
};

export default PublicRoute;
